// Base container for the app.
// data Pulled from Azure, sorted as required and passed to each component
// Component are then built into the app if there is data associated.
import React, { useContext, useState, useEffect } from "react";
import { Context } from "../Store";
import { useParams, useLocation } from "react-router-dom";
import { onAnalyticsConsent, setReVariantCookieFromUrl } from "../utils/helpers";
import Header from "../components/Header";
import Players from "../components/Players";
import ActionReplays from "../components/ActionReplays";
import Games from "../components/Games";
import CopyLinkContainer from "../components/CopyLinkContainer/CopyLinkContainer";
import LoadingStory from "../components/LoadingStory";
import { getVenueName } from "../utils/venues";
import { getStoryData } from "../utils/storyData";
import { openLightbox, updateLightbox, handleHover, updatePreview } from "../utils/storyUIHandlers";
import { StoriesAzureAPI, country } from "../utils/getStoriesAzureApi";
import Share from "../components/Share";
import NextVisit from "../components/NextVisit";
import GroupPhotosNew from "../components/GroupPhotosNew";
import Leaderboard from "../components/Leaderboard";
import Review from "../components/Review";
import TheEdgeBanner from "../components/TheEdgeBanner";
import { getVariant } from "../utils/abBucketing";
import ReviewB from "../components/ReviewB";
import ChristmasBanner from "../components/ChristmasBanner";

const StoryContainer = () => {
  // Setting app context to Store.js Where the overall state is kept
  const [state, setState] = useContext(Context);
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const debug = params.get("debug");

  // Rapid Entry variant is UK only, so the cookie is only set for UK visitors once consent is given
  useEffect(() => {
    if (country !== "uk") return;
    return onAnalyticsConsent(country, () => setReVariantCookieFromUrl(search));
  }, [search]);

  // On load will use the string after the first slash (/) as the GUID
  // to request Stories data from the Azure API. Will work both with or without the trailing #/ in the URL
  let { guid } = useParams();

  //get variant for AB test
  const variant = guid ? getVariant(guid) : "A";

  // Check if state has been set. If not get data from guid and set display to "Loading"
  if (state.guid.length < 1) {
    getStoryData({
      id: guid,
      country,
      StoriesAzureAPI,
      debug,
      getVenueName,
      setState,
      state,
    });
    return (
      <div>
        <LoadingStory />
      </div>
    );
  }

  return (
    <div>
      <Context.Provider value={state}>
        <Header />
        <Players openLightbox={openLightbox} />
        {state.actionReplays.length >= 1 && <ActionReplays handleHover={handleHover} openLightbox={openLightbox} />}
        {/* {variant === "A" && (state.feedbackurl || state.googleurl) && <Review />}
        {variant === "B" && (state.feedbackurl || state.googleurl) && <ReviewB />} */}
        {(state.feedbackurl || state.googleurl) && <Review />}
        {(state.groupPhotos.length >= 1 || state.loopcams.length >= 1) && (
          <GroupPhotosNew handleHover={handleHover} openLightbox={openLightbox} />
        )}
        <Share />
        {state.games.length >= 1 && <Games handleHover={handleHover} openLightbox={openLightbox} />}
        {state.country === "uk" && <TheEdgeBanner />}
        {state.teams.length === 0 && <Leaderboard />}
        <NextVisit />
        <ChristmasBanner />
        <CopyLinkContainer mount={updatePreview} callbackHandler={openLightbox} updateLightbox={updateLightbox} />
      </Context.Provider>
    </div>
  );
};

export default StoryContainer;
